import React from 'react';
import { motion } from 'framer-motion';
export function Solution() {
  return <section className="py-24 px-4 bg-[#FAF8F5] overflow-hidden" data-id="element-139">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-141">
          <div className="relative transform -rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-142">
            <div className="absolute inset-0 bg-[#2D2A26]/20 rounded-2xl blur-2xl translate-y-4" data-id="element-143" />
            <img src="https://cdn.magicpatterns.com/uploads/rGwrmwArt5o9JdyaaqWDRg/Generated_Image_February_04,_2026_-_4_36PM.jpg" alt="Portada del ebook: Cómo manejar la ansiedad durante la abstinencia - Guía práctica de 30 días" className="relative rounded-2xl shadow-2xl w-full max-w-md mx-auto" data-id="element-144" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-6" data-id="element-145">
          <span className="text-[#C4956A] font-semibold tracking-wide uppercase text-sm" data-id="element-146">
            La Solución
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-[#2D2A26] leading-tight" data-id="element-147">
            Un plan práctico que te dice qué hacer cada día
          </h2>
          <p className="text-lg text-[#5D5A56] leading-relaxed" data-id="element-148">
            Y qué hacer cuando la ansiedad te quiere ganar. Por eso creé esta
            guía.
          </p>

          <div className="space-y-4 pt-4" data-id="element-149">
            <div className="flex items-start gap-4" data-id="element-150">
              <div className="w-1.5 h-1.5 rounded-full bg-[#7C8B6F] mt-2.5" data-id="element-151" />
              <p className="text-[#4D4A46]" data-id="element-152">
                No es un texto para "leer bonito".{' '}
                <span className="font-semibold" data-id="element-153">Es un manual para usar.</span>
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-154">
              <div className="w-1.5 h-1.5 rounded-full bg-[#7C8B6F] mt-2.5" data-id="element-155" />
              <p className="text-[#4D4A46]" data-id="element-156">
                Diseñado especialmente para LATAM, para personas de 18 a 45
                años.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-157">
              <div className="w-1.5 h-1.5 rounded-full bg-[#7C8B6F] mt-2.5" data-id="element-158" />
              <p className="text-[#4D4A46]" data-id="element-159">
                Enfoque intermedio: si ya lo intentaste antes y quieres algo más
                estructurado.
              </p>
            </div>
          </div>

          <div className="bg-[#7C8B6F]/10 p-6 rounded-xl border border-[#7C8B6F]/20 mt-8" data-id="element-160">
            <p className="text-[#5A6650] font-medium italic" data-id="element-161">
              "Está pensado para quien hoy siente: 'No tengo apoyo profesional…
              necesito que esto me sostenga'."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}